import { StatisticsPeriod } from './statistics-period.interface';

export const buildStatisticsPeriodQuery = (period: StatisticsPeriod): string => {
  const periodQuery = new URLSearchParams({
    startDate: period.startDate.toISOString(),
    endDate: period.endDate.toISOString(),
  });

  return periodQuery.toString();
};
